import type { SxProps, Theme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

import { MonacoEditorField } from '@/components/MonacoEditor'

export interface DescriptionFieldWithFullscreenProps {
	containerSx?: SxProps<Theme>
	helperText?: string,
	onChange?: (value: string) => void,
	readOnly: boolean,
	title: string,
	value: string
}

/**
 * Description/comment field: same Monaco editor inline and in fullscreen (markdown).
 * Uses MonacoEditorField so editing experience is identical when not fullscreen.
 */
export const DescriptionFieldWithFullscreen = ({
	title,
	value,
	onChange,
	readOnly,
	helperText,
	containerSx,
}: DescriptionFieldWithFullscreenProps) => {
	return (
		<Box sx={[{ width: '100%' }, ...(containerSx ? [containerSx] : [])]}>
			<MonacoEditorField
				title={title}
				value={value ?? ''}
				onChange={onChange}
				disabled={readOnly}
				language="markdown"
				renderMarkdownWhenReadOnly
			/>
			{helperText && (
				<Typography
					variant="caption"
					color="text.secondary"
					sx={{ display: 'block', mt: 0.5, mx: 1.5 }}
				>
					{helperText}
				</Typography>
			)}
		</Box>
	)
}
